import * as ng from 'angular';
import {ArchiSmallServices} from '../../../services/archismall.service';
import {IRivenditore} from '../../interfaces/IRivenditore';

class CreateRivenditoreModalController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack',
    '$state'
  ];

  private close: any;
  private dismiss: any;

  constructor(
    private $scope: {
      rivenditore: IRivenditore
      formsubmitted?: boolean
      messaggio?: string
      [key: string]: any
    },
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $modalStack: ng.ui.bootstrap.IModalStackService,
    private $state: any
  ) {

    $scope.rivenditore = {code: undefined, name: undefined, email: undefined, _id: null};
    $scope.codeRegex = /^[a-zA-Z0-9]{5}$/;

    $scope.createReseller = () => {
      $scope.formsubmitted = true;
      if ($scope.form && !$scope.form.$valid) {
        $scope.messaggio = 'Compila correttamente tutti i campi obbligatori';
        return;
      }
      ArchiSmallServices.createRivenditore($scope.rivenditore).then(res => {
        this.close({$value: true});
      }).catch(err => {
        $scope.messaggio = `Error while creation: ${err.data.errorDescription}`;
      });

    };
    $scope.cancel = () => {
      this.close({$value: false});
    };
  }
}

export const CreateRivenditoreModalComponent: ng.IComponentOptions = {
  template: require('./create-rivenditore-modal.html'),
  controller: CreateRivenditoreModalController,
  bindings: {
    close: '&',
    dismiss: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/create-rivenditore-modal/create-rivenditore-modal.ts